import {
  ObservabilityToolType,
  TeamExternalIntegrationAuthenticationStatus,
  type TeamExternalIntegrationGcp,
  type TeamExternalIntegration
} from 'types/api/status-checks/status-check'

import type {
  AuthenticationRequestBodyGcp,
  CreateAuthenticationRequestParams
} from 'queries/external-integrations/types'

export function isTeamExternalIntegrationGcp(
  integration: TeamExternalIntegration
): integration is TeamExternalIntegrationGcp {
  const { identifier, integrationSpecificValues, observabilityToolType } =
    integration

  return Boolean(
    identifier &&
      observabilityToolType === ObservabilityToolType.GCP &&
      integrationSpecificValues?.serviceAccount
  )
}

export function getGcpAuthenticationPayload(
  serviceAccountId: string
): [CreateAuthenticationRequestParams, AuthenticationRequestBodyGcp] {
  const observabilityToolType = ObservabilityToolType.GCP

  return [
    {
      observabilityToolType
    },
    {
      integrationSpecificValues: { serviceAccount: serviceAccountId },
      name: observabilityToolType,
      privateNetwork: false,
      lastAuthenticationStatus:
        TeamExternalIntegrationAuthenticationStatus.Authenticated
    }
  ]
}
